import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';

import type { TImage } from '@shared/types/image';
import { showToast } from '@src/shared/utils/helpers/show-toast';

export const deleteMedia = async (id: number): Promise<TImage> => {
  const res = await request({
    url: `media/${id}/`,
    method: 'DELETE',
  });

  return res;
};

export const useDeleteMedia = () => {
  return useMutation({
    mutationFn: deleteMedia,

    onSuccess: () => {
      showToast({
        title: 'Media deleted',
        description: 'Media has been deleted successfully.',
        variant: 'success',
      });
    },
  });
};
